import ProgressBar from './ProgressBar';
import {
    getCurrTest,
    orderedTest,
    setCurrTest,
    setSubmissionNum,
    setTestList,
    TEST_KEY,
    testToStep,
} from './constants';
import { cEl } from '../../../util';
import SelfDiagnosticTestFooter from './StaticContents/SelfDiagnosticTestFooter/SelfDiagnosticTestFooter';
import TestPage from './TestPage';
import QuestionFooter from './TestPage/QuestionFooter';
import TestResultFooter from './StaticContents/TestResult/Footer';

function Test() {
    const testContainer = cEl('div');
    testContainer.classList.add('test-main-container');
    initialTest();

    testRenderer(getCurrTest(), testContainer);

    return testContainer;
}

const initialTest = () => {
    setCurrTest({ ...orderedTest[0] });
    setTestList([...orderedTest.filter(testInfo => !testInfo.subTitle)]);
    setSubmissionNum(null);
};

export const testRenderer = (currentTest, testContainer) => {
    const newTestContainer = testContainer ?? document.querySelector('.test-main-container');
    setCurrTest({ ...currentTest });
    if (newTestContainer) {
        newTestContainer.innerHTML = '';
        newTestContainer.append(
            ProgressBar(currentTest),
            testContentsRenderer(currentTest),
            testFooterRenderer(currentTest),
        );
    }
};

const testContentsRenderer = currentTest => {
    const currentTestQuestions = testToStep[currentTest.key];
    if (currentTestQuestions[currentTest.questionNum]?.contents) {
        if (typeof currentTestQuestions[currentTest.questionNum]?.contents === 'function') {
            return currentTestQuestions[currentTest.questionNum]?.contents();
        }
        return currentTestQuestions[currentTest.questionNum]?.contents;
    }
    if (currentTestQuestions[currentTest.questionNum].questionText) {
        return TestPage();
    }
};

const testFooterRenderer = currentTest => {
    switch (currentTest.key) {
        case TEST_KEY.SELF_ASSESSMENT:
            return SelfDiagnosticTestFooter();
        case TEST_KEY.TEST_RESULT:
            return TestResultFooter();
        default:
            return QuestionFooter();
    }
};

export default Test;
